// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/Vector Lines.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../images/Group 873.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../images/Group 874.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Inter", sans-serif;
}

html {
  scroll-snap-type: y mandatory;
  scroll-behavior: smooth;
}

.container {
  height: auto;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
}

.web_container {
  scroll-behavior: smooth;
  overflow-y: scroll;
}

.hero-container {
  height: 90vh;
  scroll-snap-align: center;
  margin-top: 10%;
  display: flex;
  flex-direction: column;
}

.hero-content {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center;
  background-size: contain;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #f4f4f4;
  height: 100%;
  width: 100%;
  margin: 0 auto;
}

.hero-content h1 {
  word-break: keep-all;
  display: inline-block;
  width: 60vw;
  font-family: Eczar;
  font-size: 56px;
  font-weight: 600;
  letter-spacing: 0em;
  text-align: center;
  line-height: 100px;
  overflow-wrap: break-word;
}

.custom-heading span {
  font-family: Eczar;
  font-size: 56px;
}

.hero-content p {
  font-size: 1rem;
  background: #15141d;
  font-family: inter;
  word-spacing: 1px;
  font-weight: 400;
  height: auto;
  line-height: 34px;
  text-align: center;
  color: #b3b3b3;
  max-width: 820px;
  margin: 8px auto 0;
}

.reserve-btns {
  background: transparent;
  margin: 0 8px;
}

.hero-buttons {
  display: flex;
  gap: 16px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 24px;
}

.reserve-btns button {
  height: 52px;
  font-size: 1rem;
  font-family: inter;
  font-weight: 600;
  border-radius: 14px;
  border: 0;
  justify-content: center;
  padding: 0 22px;
  min-width: 200px;
  color: #0b0b0f;
  background: linear-gradient(90deg, #ff6b35, #fb8500);
  box-shadow: 0 10px 24px rgba(251, 133, 0, 0.25);
  transition: transform 0.15s ease, box-shadow 0.2s ease, filter 0.2s ease;
}

.reserve-btns button:hover {
  transform: translateY(-1px);
  box-shadow: 0 14px 30px rgba(251, 133, 0, 0.35);
  filter: saturate(1.05);
}

.reserve-btns button:active {
  transform: translateY(0);
  box-shadow: 0 6px 14px rgba(251, 133, 0, 0.25);
}

.whitestar {
  position: absolute;
  right: 18%;
  top: 16%;
  background: transparent;
}

.hero-content img {
  width: 30px;
  height: 30px;
}

.hero-content span {
  font-size: 56px;
  font-family: Ezcar;
}

.polygondeep {
  position: absolute;
  left: 20%;
  bottom: 36%;
  background: transparent;
}

.bluestar {
  position: absolute;
  right: 10%;
  bottom: 8%;
  background: transparent;
}

.light {
  position: absolute;
  left: 14%;
  background: transparent;
}

.deep {
  position: relative;
  position: absolute;
  right: 10%;
  bottom: -37%;
  background: transparent;
}

.maintext_para {
  background: transparent;
}

.maintext_para p {
  width: 80%;
  margin: 5% auto;
  justify-content: center;
  display: flex;
  background: transparent;
}

/* about section */
.about_scroll {
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  text-align: center;
}

.about_scroll h1 {
  margin: auto;
  margin-bottom: 2rem;
}

/* .main_wrapper {
  margin-top: 72px;
} */

.main_wrapper .about_scroll p {
  width: 80%;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin: 0 auto 100px;
}

.main_wrapper h1 {
  font-family: Eczar;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 3rem;
  color: #fff;
}

.main_wrapper p,
.main_wrapper .about_scroll p {
  background: #15141d;
  color: #b3b3b3;
  font-family: Inter;
  font-size: 1rem;
  font-weight: 400;
  line-height: 32px;
  text-align: center;
}

.orange {
  color: rgba(251, 133, 0, 1);
}

.yellow {
  color: rgba(239, 160, 11, 1);
}

.blue {
  color: rgba(33, 158, 188, 1);
}

/* DATA MASTERY AND TRACK */
.datamastery-container {
  color: #fff;
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  border-radius: 16px;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: auto;
  border: 3px solid rgba(75, 75, 75, 0.25);
}

.datamastery-wrapper {
  border-radius: 16px;
  margin: 1rem auto;
}

.datamastery-info,
.data-firsttext,
.datamastery-info h2,
.datamastery-info p,
.datamastery-info .orange {
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%
    );
}

.datamastery-wrapper {
  background-color: rgba(28, 27, 38, 1);
  border-radius: 16px;
}

.datamastery-info h2 {
  color: #f4f4f4;
  font-family: Eczar;
  font-size: 3rem;
  font-weight: 700;
  line-height: 5rem;
  height: 170px;
  padding-top: 1rem;
}

.datamastery-info h2,
.datamastery-info p {
  text-align: center;
  justify-content: center;
  width: 80%;
  margin: auto;
  align-items: center;
}

.datamastery-info p {
  color: rgba(179, 179, 179, 1);
  font-weight: 400;
  letter-spacing: 0em;
  margin: 1rem auto;
  font-family: Inter;
  font-size: 1rem;
}

.track-type {
  border-radius: 16px;
  color: #f4f4f4;
  background: linear-gradient(0deg, #1c1b26, #1c1b26),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.5) 0%,
      rgba(255, 255, 255, 0) 100%
    );
  justify-content: center;
  flex-wrap: wrap;
}

.track {
  justify-content: center;
  align-items: center;
  padding: 2px 12px;
  min-width: 350px;
  border: 12px solid rgba(75, 75, 75, 0.25);
  border-radius: 16px;
}

.track_info {
  border-radius: 10px;
}

.wrapper {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  max-width: 1400px;
  width: 100%;
}

.beginner-type,
.intermediate-type {
  width: 100%;
  justify-content: center;
  align-items: center;
  margin: 1rem auto;
  display: flex;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: center;
  border-radius: 1rem;
  background-size: contain;
}

.beginner-type h2,
.intermediate-type h2 {
  font-family: Eczar;
  margin: auto;
  justify-content: center;
  align-items: center;
  height: 7rem;
  width: 100%;
  border-radius: 1rem;
  display: flex;
  font-size: 1.6rem;
  font-weight: 800;
  line-height: 2.4rem;
  text-align: center;
  padding: 1%;
}

.beginner-type h2 {
  background-color: rgba(207, 112, 3, 0.904);
}

.intermediate-type h2 {
  background-color: rgba(9, 202, 250, 0.911);
}

.notes {
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 30%;
  /* min-width: 250px; */
  max-width: 400px;
  text-align: center;
}

.notes h4 {
  width: 300px;
  font-size: 16px;
  font-weight: 600;
  font-family: Eczar;
  line-height: 32px;
  margin: auto;
  display: flex;
  text-align: left;
  margin-top: 8px;
}

.notes p {
  font-family: Inter;
  font-size: 14px;
  line-height: 22px;
  text-align: left;
  margin: 1rem auto;
  width: 300px;
  font-weight: 400;
}

.track_btn {
  width: 100%;
  gap: 0;
}

.track_btn .track_modules {
  width: 100%;
  height: 40px;
  margin: 2rem auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.track_modules .week-button {
  margin: 1rem auto;
  width: 100%;
}

.track_btn button {
  background-color: rgba(75, 75, 75, 0.5);
  border-style: none;
  color: #f4f4f4;
  width: 90%;
  height: 38px;
  border-radius: 4px;
}

.click_button {
  width: 100%;
}

.track_select_btn button {
  background-color: rgba(251, 133, 0, 1);
  /* padding: 0.5rem 0.2rem; */
}

.track_select_btn button,
.track_select_btn2 button {
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  line-height: 32px;
}

.track_select_btn2 button {
  background: rgba(33, 158, 188, 1);
}

.orange,
.yellow,
.blue {
  font-family: Eczar;
}

/* Mentor's info section */

.main_wrapper .mentors {
  color: #fff;
  border-radius: 16px;
  height: 70%;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 3rem auto;
  /* background-color: green; */
}

.mentors_images_container {
  margin: 0 auto;
}

.ment .mentors_container h3 {
  font-size: 18px;
  width: 100%;
}

.ment .mentors_container p {
  font-size: 12px;
}

.mentors_container {
  gap: 40px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 40px auto;
  justify-content: space-around;
  /* justify-content: center; */
  align-items: center;
  /* background-color: red; */
}

.mentor_wraps {
  gap: 20px;
  background-color: transparent;
  transition: 1.5s;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
}

.mentor_image_wrap {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.ment .mentor_wraps .mentor_para {
  background: rgba(21, 20, 29, 1);
}

.mentor_wraps:hover {
  transform: scale(1.01);
  box-shadow: 0 0 30px -10px rgba(8, 8, 6, 0.25);
}

.ment .mentor_wraps p,
.ment .mentor_wraps h3 {
  background: rgba(21, 20, 29, 1);
  text-align: center;
}

.ment .mentor_wraps {
  background: rgba(21, 20, 29, 1);
}

.mentors .ment h1 {
  height: auto;
}

.mentors .ment h1 .oranges {
  color: rgba(251, 133, 0, 1);
  font-family: Eczar;
}

.new_mentor_para {
  width: 50vw;
  text-align: justify;
  margin: 0 auto;
}

.mentor_para {
  color: #fff;
  display: block;
  text-align: center;
  border: none;
  text-align: left;
  margin: 0.4rem;
  /* background-color: rgba(28, 27, 38, 1); */
}

.mentors .mentors_text p {
  width: 60%;
  color: #b3b3b3;
}

.mentor_image {
  width: 250px;
  height: 250px;
  border-radius: 50%;
  object-fit: cover;
  overflow: hidden;
  display: block;
  margin: 0 auto;
}

.ment .mentors_text {
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 72px auto 0;
}

.ment .mentors_text {
  margin-bottom: 18px;
}

.mentors_text h1 {
  font-family: Eczar;
  color: #fff;
  font-size: 48px;
  width: 469px;
  height: 85px;
}

.mentors_text .oranges {
  font-size: 48px;
  line-height: 70px;
  color: rgba(251, 133, 0, 1);
  font-family: Eczar;
}

.dataepic_mentors_text .oranges {
  font-size: 48px;
  line-height: 70px;
  color: rgba(251, 133, 0, 1);
  font-family: Eczar;
}

.dataepic_mentors_text p {
  font-family: Inter;
  line-height: 32px;
  font-weight: 400;
  text-align: center;
  font-size: 16px;
  margin-bottom: 40px;
  width: 60%;
}

/* dataepic */

.main_wrapper .data_new {
  width: 100%;
}

.main_wrapper .data_epic {
  border-radius: 16px;
  height: 70%;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0 auto 0;
  /* background-color: yellow; */
}

.dataepic_container {
  width: 100%;
  gap: 20px;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: space-between;
}

.dataepic_mentors_text {
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  height: 190px;
  margin-bottom: 30px;
  margin-top: 72px;
}

.data_new {
  border-radius: 16px;
}

.dataepic_wrap {
  box-sizing: border-box;
  flex-wrap: wrap;
  transition: 0.8s;
  border: 3px solid rgba(245, 238, 238, 0.035);
  border-radius: 16px;
  color: #fff;
  width: 80%;
  /* min-width: 18.75rem; */
  margin-bottom: 20px;
  justify-content: space-between;
  align-content: space-between;
  text-align: center;
  text-align: left;
  background-color: rgba(28, 27, 38, 1);
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(33.33% - 16px);
}

.data_epic .dataepic_para {
  background-color: rgba(28, 27, 38, 1);
}

.dataepic_wrap:hover {
  transform: scale(1.03);
  box-shadow: rgba(34, 1, 1, 0.25);
}

.dataepic_images {
  height: 85px;
  border-radius: 16px;
  padding: 0px 16px 18px 16px;
  background-color: rgba(28, 27, 38, 1);
}

.dataepic_para {
  border-radius: 12px;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  margin-left: 0.5rem;
}

.dataepic_para h3 {
  justify-content: center;
  text-align: left;
  align-items: center;
  padding: 2px 16px 18px 16px;
  font-family: Eczar;
  font-size: 22px;
  font-weight: 600;
  background-color: rgba(28, 27, 38, 1);
}

.dataepic_para p {
  font-size: 16px;
  font-family: Inter;
  padding: 0px 16px 12px 16px;
  background-color: rgba(28, 27, 38, 1);
  margin-bottom: 10px;
  line-height: 30px;
  font-weight: 400;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
  color: #b3b3b3;
}

.dataepic_images img {
  margin-top: 24px;
  height: 50px;
  width: 50px;
  justify-items: center;
  background-color: rgba(28, 27, 38, 1);
}

/* play session */

.main_wrapper .session_container {
  width: 100%;
  text-align: center;
  justify-content: center;
  display: flex;
  margin: 72px auto 36px;
}

.session_container h1 {
  font-family: Eczar;
  color: #f4f4f4;
  font-size: 48px;
  line-height: 70px;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  margin: 0 auto;
  height: 170px;
  /* background-color: red; */
}

.session_container .oranges {
  font-size: 48px;
  line-height: 70px;
  color: rgba(251, 133, 0, 1);
  font-family: Eczar;
}

.play_session {
  color: #f4f4f4;
  align-items: center;
  justify-content: center;
  margin: auto;
}

.playback_sessions {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: auto;
  border-radius: 15px;
  border: 3px solid rgba(245, 238, 238, 0.159);
  gap: 1rem;
  /* margin-bottom: 72px; */
}

.playback {
  /* height: 370px; */
  justify-content: center;
  align-items: center;
  margin: 2% auto;
  /* width: fit-content; */
  /* min-width: 20rem; */
}

/* .playback .entry {
  height: 20px;
  width: 33%;
  margin: 0 auto;
} */

.playback .entry {
  max-width: fit-content;
  margin: 0 auto;
}

.entry_level {
  margin: 0 auto;
  display: flex;
}

.main_faqwrapper .mentors_textt {
  justify-content: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 48px auto;
  /* height: 180px; */
}

.mentors_textt h1 {
  font-family: Eczar;
  color: #f4f4f4;
  font-size: 48px;
  width: 100%;
  height: auto;
  /* background-color: purple; */
}

.mentors_textt .oranges {
  font-size: 48px;
  line-height: 70px;
  color: rgba(251, 133, 0, 1);
  font-family: Eczar;
}

.accordion_one {
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin: 50px auto 0;
}

.accordion_two {
  width: 100%;
  color: #b3b3b3;
}

.accordion_three {
  display: flex;
  background-color: rgba(28, 27, 38, 1);
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.item {
  cursor: pointer;
  margin-bottom: 5px;
  /* padding: 30px 40px; */
}

.accordion_three h2 {
  background-color: rgba(28, 27, 38, 1);
  font-family: Eczar;
  font-size: 24px;
  font-weight: 400;
}

.accordion_four {
  background-color: rgba(28, 27, 38, 1);
  height: auto;
  max-height: 9999px;
  transition: all 1.2s cubic-bezier(1, 1, 0, 0);
}

.accordion_four:hover {
  background-color: rgba(28, 27, 38, 1);
  transform: scale(0.8);
}

.accordion_four p {
  background-color: rgba(28, 27, 38, 1);
  text-align: left;
}

.accordion_three h2:hover {
  background-color: rgba(28, 27, 38, 1);
  transform: scale(1);
  box-shadow: 0 0 40px -10px rgba(8, 8, 6, 0.25);
  transition: (1.5s);
}

.accordion_five {
  background-color: rgba(28, 27, 38, 1);
  max-height: 0;
  overflow: hidden;
  transition: all 1.5s cubic-bezier(1, 1, 1, 1);
}

.accordion_five p {
  background-color: rgba(28, 27, 38, 1);
  text-align: left;
}

.sign {
  background-color: rgba(28, 27, 38, 1);
  padding-right: 12px;
}

@media (min-width: 1200px) {
  .about_scroll,
  .datamastery-container {
    padding: 0;
  }

  .about_scroll h1 {
    width: 100%;
  }

  .main_wrapper .datamastery-container {
    height: 110vh;
    padding: 10px;
    width: 96%;
  }

  .datamastery-info p {
    padding: 1%;
  }

  #track,
  #track_second,
  #last_track {
    height: auto;
  }

  .dataepic_container,
  .play_session {
    width: 90%;
  }

  .main_faqwrapper {
    width: 90%;
    margin: 0 auto;
  }

  .notes,
  .notes p {
    padding: 0;
    margin-bottom: 0;
  }
}

@media (min-width: 992px) and (max-width: 1199.98px) {
  .hero-content p {
    margin-top: 10%;
  }

  .main_wrapper .datamastery-container {
    width: 90%;
    height: 130vh;
  }

  .main_wrapper .datamastery-wrapper {
    height: 100%;
    padding: 0;
    margin: 0;
  }

  .datamastery-info,
  .hero-content p {
    background: transparent;
  }

  .track-type .track {
    width: 31%;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }

  #track,
  #track_second,
  #last_track {
    height: auto;
  }

  .notes {
    width: 100%;
    padding: 0;
    /* height: 200px; */
    /* max-height: 300px; */
    margin: 0 auto;
  }

  .notes h4 {
    margin: 0 auto;
    width: 100%;
    height: 100%;
  }

  .notes p {
    max-width: 100%;
    width: 100%;
    padding: 0;
  }

  .track_btn {
    width: 100%;
  }

  .track_btn .track_modules {
    margin: 0 auto;
    margin-bottom: 1rem;
  }

  .track_modules .week-button {
    width: 80%;
  }

  .track_select_btn button,
  .track_select_btn2 button {
    width: 100%;
    padding-left: 1px;
    padding-right: 1px;
  }

  .beginner-type h2,
  .intermediate-type h2 {
    font-size: 1.6rem;
  }

  .new_mentor_para p {
    padding: 20px;
    width: 80%;
    margin: 0 auto;
  }

  .mentors_container {
    width: 90%;
  }

  .mentor_wraps {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }

  .dataepic_mentors_text,
  .main_faqwrapper {
    width: 90%;
    margin: 0 auto;
  }

  .hero-content,
  .about_scroll,
  .about_scroll,
  .session_container h1,
  .new_mentor_para {
    width: 90%;
  }

  .dataepic_mentors_text p {
    width: 80%;
  }

  .dataepic_container {
    width: 90%;
    gap: 20px;
  }

  .dataepic_images {
    padding: 0.5rem;
  }

  .dataepic_para h3,
  .dataepic_para p {
    padding: 0;
  }

  .dataepic_para {
    width: 100%;
    margin: 0 auto;
    padding: 0.5rem;
  }
  .play_session {
    width: 96%;
  }
  .playback {
    background-color: transparent;
    display: flex;
  }
  .playback_sessions img {
    width: 90%;
    margin: auto 10px;
    padding: 2%;
  }
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .container {
    width: 90%;
  }

  .about_scroll {
    width: 80%;
  }

  .main_wrapper .datamastery-container {
    height: 190vh;
  }

  .datamastery-info h2 {
    font-size: 2.5rem;
    line-height: 4rem;
  }

  .datamastery-info p {
    padding: 0;
    padding-bottom: 2%;
  }

  #track,
  #track_second,
  #last_track {
    height: auto;
  }

  .track_btn .track_modules {
    margin: 0 auto;
    margin-bottom: 1rem;
  }

  .new_mentor_para {
    width: 80%;
  }

  .mentors_container {
    display: grid;
  }

  .mentor_wraps {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }

  .dataepic_para {
    height: auto;
    padding: 0;
    margin: 0;
  }

  .dataepic_mentors_text p {
    width: 80%;
  }

  .dataepic_images {
    padding: 0.5rem;
  }

  .dataepic_para h3 {
    height: 80px;
    margin: 0;
    padding: 8px 10px 0 10px;
  }

  .dataepic_para p {
    padding: 0 10px 0 10px;
  }
  .playback_sessions {
    width: 100%;
  }
  .playback_sessions img {
    width: 200px;
  }

  .playback {
    width: 100%;
  }

  .play_session {
    width: 96%;
  }
  .playback {
    background-color: transparent;
    display: flex;
  }
}

@media (min-width: 768px) and (max-width: 830px) {
  .main_wrapper .datamastery-container {
    height: 220vh;
  }

  .about_scroll,
  .track-type {
    width: 100%;
  }

  .wrapper {
    width: 100%;
  }

  .beginner-type,
  .intermediate-type {
    width: 90%;
  }

  .beginner-type h2,
  .intermediate-type h2 {
    height: 6rem;
    font-size: 2rem;
  }

  .track-type,
  .wrapper,
  #track,
  #track_second,
  #last_track {
    width: 90%;
    margin: 0 auto;
  }

  .notes {
    width: 100%;
    max-width: 90%;
    margin: 0 auto;
    padding: 0;
  }

  .notes h4,
  .notes p {
    width: 100%;
    padding: 0;
    text-align: left;
    justify-content: left;
  }

  .track_btn {
    width: 90%;
    margin: 0 auto;
  }

  .track_btn .track_modules {
    width: 100%;
    gap: 20px;
  }

  .track_btn button {
    width: 100%;
    gap: 10px;
  }

  .track_select_btn button,
  .track_select_btn2 button {
    width: 90%;
    margin: 0 auto;
  }

  /* .dataepic_wrap {
    margin: 0 auto;
    height: 100%;
    background-color: orange;
  } */

  .dataepic_para h3 {
    margin: 0;
    height: 10%;
  }
}

@media screen and (max-width: 768px) {
  .container {
    width: 90%;
  }

  .dataepic_wrap {
    flex: 1 1 100%;
  }

  .about_scroll {
    width: 100%;
  }

  .mentors_textt h1,
  .session_container h1,
  .dataepic_mentors_text h1,
  .datamastery-info h2 {
    font-size: 2rem;
    line-height: 60px;
  }

  .maintext_para p {
    font-size: 1rem;
    width: 96%;
    height: auto;
  }

  .about_scroll,
  .track-type {
    width: 100%;
  }

  .about_scroll h1 {
    font-size: 1.6rem;
    line-height: 1.7;
  }

  .about_scroll .mini-text p {
    font-size: 1rem;
    width: 96%;
    margin: 2rem auto;
  }

  .red {
    padding: 0;
    margin: 0;
  }

  .datamastery-info h2 {
    line-height: 1.5;
    font-size: 40px;
    width: 90%;
    margin-top: 0.6rem;
    margin-bottom: 1rem;
  }

  .datamastery-info p {
    margin: 0 auto;
    padding: 0;
    width: 90%;
    font-size: 16px;
    font-family: "Inter", sans-serif;
    line-height: 1.5;
    font-weight: 400;
  }

  .wrapper {
    width: 100%;
  }

  #track,
  #track_second,
  #last_track {
    width: 100%;
    height: auto;
  }

  .beginner-type,
  .intermediate-type {
    width: 98%;
  }

  .beginner-type h2,
  .intermediate-type h2,
  .new_mentor_para h1 {
    font-size: 36px;
    padding: 0.2rem;
    line-height: 1.1;
  }

  .track-type,
  .wrapper {
    width: 98%;
    margin: 1rem auto;
    height: auto;
  }

  .notes {
    width: 100%;
    max-width: 96%;
    margin: 0 auto;
    padding: 0;
  }

  .notes h4,
  .notes p {
    width: 100%;
    padding: 0;
    text-align: left;
    justify-content: left;
  }

  .notes h4 {
    font-size: 20px;
  }

  .note p {
    font-size: 16px;
  }

  .track_btn {
    width: 100%;
    margin: 0 auto;
  }

  .track_btn button {
    width: 96%;
    line-height: 1.2;
    height: 45px;
  }

  .click_button {
    width: 100%;
  }

  .new_mentor_para h1 {
    margin: 1rem auto;
  }

  .new_mentor_para h1,
  .new_mentor_para .oranges {
    font-size: 48px;
    background-color: transparent;
  }

  .new_mentor_para p {
    font-size: 16px;
  }

  .new_mentor_para,
  .new_mentor_para p {
    width: 100%;
  }

  .mentors_container {
    width: 100%;
    display: grid;
    padding: 0;
  }

  .mentor_wraps {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  }

  .mentor_para {
    margin: 0;
  }

  .mentor_para p,
  .mentor_para h3 {
    line-height: 1.2;
  }

  .dataepic_mentors_text {
    margin: 4rem auto;
    width: 100%;
    padding: 0;
  }

  .dataepic_mentors_text h1,
  .dataepic_mentors_text h1 .oranges {
    font-size: 48px;
  }
  .dataepic_mentors_text p {
    width: 100%;
    margin: 0;
  }

  .dataepic_container {
    width: 100%;
    flex-direction: column;
  }

  .dataepic_wrap {
    margin: 0 auto;
    width: 100%;
  }

  .dataepic_para h3 {
    margin: 0;
  }

  .session_container {
    margin: 0;
    padding: 0;
  }

  .session_container h1,
  .session_container .oranges {
    line-height: 1.5;
    font-size: 48px;
    height: auto;
    margin: 2rem auto;
  }

  .playback_sessions {
    display: grid;
    width: 100%;
    gap: 1rem;
  }

  .playback {
    display: flex;
  }

  .playback img {
    width: 100%;
    margin: 0;
  }

  .mentors_textt .oranges,
  .mentors_textt h1 {
    font-size: 48px;
    line-height: 1.5;
  }
}

/* Extra small devices (phones) */
@media screen and (max-width: 576px) {
  .datamastery-container h2,
  .dataepic_mentors_text h1,
  .dataepic_mentors_text h1 .oranges,
  .new_mentor_para h1,
  .new_mentor_para h1 .oranges,
  .session_container h1,
  .session_container h1 .oranges,
  .mentors_textt h1,
  .mentors_textt h1 .oranges {
    font-size: 30px;
    width: 96%;
  }

  .session_container h1,
  .session_container h1 .oranges{
    margin: 0;
    padding: 0;
    background-color: transparent;
    line-height: 1.2;
    margin-bottom: 24px;
  }
  .beginner-type,
  .beginner-type h2,
  .intermediate-type h2 {
    width: 100%;
    font-size: 1.3em;
  }
  .dataepic_wrap{
    margin-top: 24px;
  }
   .dataepic_para h3,
  .dataepic_para p {
      padding: 0px 2px 2px 2px;

  }
.faq-wrappers{
  margin: 0;
}
  .accordion_three h2{
    font-size: 18px;
  }

  .accordion_four p{
    font-size: 16px;
    line-height: 1.5;
  }
}

/* Small devices (tablets) */
@media screen and (max-width: 768px) {
  .hero-container {
    min-height: auto;
  }

  .track {
    min-width: unset;
  }

  .mentors_text h1 {
    width: unset;
  }

  .mentors_text p {
    width: unset !important;
    padding-inline: clamp(1rem, 5%, 2rem);
  }

  .web_container {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .web_container::-webkit-scrollbar,
  .hero-container::-webkit-scrollbar,
  .trackmain_container::-webkit-scrollbar {
    display: none;
  }
}

/* Medium devices (laptops) */
@media screen and (max-width: 992px) {
}

/* Large devices (desktops) */
@media screen and (max-width: 1200px) {
}

/* Extra large devices */
@media screen and (max-width: 1400px) {
}
`, "",{"version":3,"sources":["webpack://./src/styles/Home.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yDAAkD;EAClD,2BAA2B;EAC3B,wBAAwB;EACxB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oDAAoD;EACpD,+CAA+C;EAC/C,wEAAwE;AAC1E;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;GAEG;;AAEH;EACE,UAAU;EACV,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX;;;;;KAKG;EACH,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;;;;EAKE;;;;;KAKG;AACL;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd;;;;;KAKG;EACH,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;EACb;2CACiC;EACjC,2BAA2B;EAC3B,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,MAAM;AACR;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA,0BAA0B;;AAE1B;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,gBAAgB;EAChB,aAAa;EACb,4DAA4D;AAC9D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;;EAEE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,UAAU;AACZ;;AAEA,aAAa;;AAEb;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,SAAS;EACT,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,4CAA4C;EAC5C,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;EACrC,YAA6B;EAA7B,cAA6B;EAA7B,+BAA6B;AAC/B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA,iBAAiB;;AAEjB;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,4CAA4C;EAC5C,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;;;;GAIG;;AAEH;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,WAAW;EACX,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE;;IAEE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;;;IAGE,YAAY;EACd;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,cAAc;EAChB;;EAEA;;IAEE,UAAU;IACV,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,SAAS;EACX;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,UAAU;IACV,4DAA4D;EAC9D;;EAEA;;;IAGE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;;IAEE,WAAW;IACX,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,4DAA4D;EAC9D;;EAEA;;IAEE,UAAU;IACV,cAAc;EAChB;;EAEA;;;;;IAKE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,cAAc;IACd,eAAe;EACjB;EACA;IACE,UAAU;EACZ;EACA;IACE,6BAA6B;IAC7B,aAAa;EACf;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;;;IAGE,YAAY;EACd;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,4DAA4D;EAC9D;;EAEA;IACE,YAAY;IACZ,UAAU;IACV,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,SAAS;IACT,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;EACA;IACE,WAAW;EACb;EACA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;EACA;IACE,6BAA6B;IAC7B,aAAa;EACf;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;;;;;IAKE,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,cAAc;IACd,UAAU;EACZ;;EAEA;;IAEE,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;;IAEE,UAAU;IACV,cAAc;EAChB;;EAEA;;;;KAIG;;EAEH;IACE,SAAS;IACT,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;;;;IAIE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,UAAU;IACV,YAAY;EACd;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,UAAU;IACV,UAAU;IACV,eAAe;IACf,gCAAgC;IAChC,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;;;IAGE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,UAAU;EACZ;;EAEA;;;IAGE,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,UAAU;IACV,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,cAAc;IACd,cAAc;IACd,UAAU;EACZ;;EAEA;;IAEE,WAAW;IACX,UAAU;IACV,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,eAAe;IACf,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,4DAA4D;EAC9D;;EAEA;IACE,SAAS;EACX;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,UAAU;EACZ;;EAEA;;IAEE,eAAe;EACjB;EACA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;;IAEE,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,iCAAiC;AACjC;EACE;;;;;;;;;IASE,eAAe;IACf,UAAU;EACZ;;EAEA;;IAEE,SAAS;IACT,UAAU;IACV,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;EACrB;EACA;;;IAGE,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;GACC;;MAEG,wBAAwB;;EAE5B;AACF;EACE,SAAS;AACX;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA,4BAA4B;AAC5B;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;IACvB,qCAAqC;EACvC;;EAEA;IACE,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;;;IAGE,aAAa;EACf;AACF;;AAEA,6BAA6B;AAC7B;AACA;;AAEA,6BAA6B;AAC7B;AACA;;AAEA,wBAAwB;AACxB;AACA","sourcesContent":["* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-family: \"Inter\", sans-serif;\n}\n\nhtml {\n  scroll-snap-type: y mandatory;\n  scroll-behavior: smooth;\n}\n\n.container {\n  height: auto;\n  max-width: 1200px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.web_container {\n  scroll-behavior: smooth;\n  overflow-y: scroll;\n}\n\n.hero-container {\n  height: 90vh;\n  scroll-snap-align: center;\n  margin-top: 10%;\n  display: flex;\n  flex-direction: column;\n}\n\n.hero-content {\n  background-image: url(../images/Vector\\ Lines.png);\n  background-position: center;\n  background-size: contain;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  color: #f4f4f4;\n  height: 100%;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.hero-content h1 {\n  word-break: keep-all;\n  display: inline-block;\n  width: 60vw;\n  font-family: Eczar;\n  font-size: 56px;\n  font-weight: 600;\n  letter-spacing: 0em;\n  text-align: center;\n  line-height: 100px;\n  overflow-wrap: break-word;\n}\n\n.custom-heading span {\n  font-family: Eczar;\n  font-size: 56px;\n}\n\n.hero-content p {\n  font-size: 1rem;\n  background: #15141d;\n  font-family: inter;\n  word-spacing: 1px;\n  font-weight: 400;\n  height: auto;\n  line-height: 34px;\n  text-align: center;\n  color: #b3b3b3;\n  max-width: 820px;\n  margin: 8px auto 0;\n}\n\n.reserve-btns {\n  background: transparent;\n  margin: 0 8px;\n}\n\n.hero-buttons {\n  display: flex;\n  gap: 16px;\n  justify-content: center;\n  flex-wrap: wrap;\n  margin-top: 24px;\n}\n\n.reserve-btns button {\n  height: 52px;\n  font-size: 1rem;\n  font-family: inter;\n  font-weight: 600;\n  border-radius: 14px;\n  border: 0;\n  justify-content: center;\n  padding: 0 22px;\n  min-width: 200px;\n  color: #0b0b0f;\n  background: linear-gradient(90deg, #ff6b35, #fb8500);\n  box-shadow: 0 10px 24px rgba(251, 133, 0, 0.25);\n  transition: transform 0.15s ease, box-shadow 0.2s ease, filter 0.2s ease;\n}\n\n.reserve-btns button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 14px 30px rgba(251, 133, 0, 0.35);\n  filter: saturate(1.05);\n}\n\n.reserve-btns button:active {\n  transform: translateY(0);\n  box-shadow: 0 6px 14px rgba(251, 133, 0, 0.25);\n}\n\n.whitestar {\n  position: absolute;\n  right: 18%;\n  top: 16%;\n  background: transparent;\n}\n\n.hero-content img {\n  width: 30px;\n  height: 30px;\n}\n\n.hero-content span {\n  font-size: 56px;\n  font-family: Ezcar;\n}\n\n.polygondeep {\n  position: absolute;\n  left: 20%;\n  bottom: 36%;\n  background: transparent;\n}\n\n.bluestar {\n  position: absolute;\n  right: 10%;\n  bottom: 8%;\n  background: transparent;\n}\n\n.light {\n  position: absolute;\n  left: 14%;\n  background: transparent;\n}\n\n.deep {\n  position: relative;\n  position: absolute;\n  right: 10%;\n  bottom: -37%;\n  background: transparent;\n}\n\n.maintext_para {\n  background: transparent;\n}\n\n.maintext_para p {\n  width: 80%;\n  margin: 5% auto;\n  justify-content: center;\n  display: flex;\n  background: transparent;\n}\n\n/* about section */\n.about_scroll {\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.about_scroll h1 {\n  margin: auto;\n  margin-bottom: 2rem;\n}\n\n/* .main_wrapper {\n  margin-top: 72px;\n} */\n\n.main_wrapper .about_scroll p {\n  width: 80%;\n  justify-content: center;\n  align-items: center;\n  margin: 0 auto;\n  margin: 0 auto 100px;\n}\n\n.main_wrapper h1 {\n  font-family: Eczar;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  font-size: 3rem;\n  color: #fff;\n}\n\n.main_wrapper p,\n.main_wrapper .about_scroll p {\n  background: #15141d;\n  color: #b3b3b3;\n  font-family: Inter;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 32px;\n  text-align: center;\n}\n\n.orange {\n  color: rgba(251, 133, 0, 1);\n}\n\n.yellow {\n  color: rgba(239, 160, 11, 1);\n}\n\n.blue {\n  color: rgba(33, 158, 188, 1);\n}\n\n/* DATA MASTERY AND TRACK */\n.datamastery-container {\n  color: #fff;\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n  border-radius: 16px;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  margin: auto;\n  border: 3px solid rgba(75, 75, 75, 0.25);\n}\n\n.datamastery-wrapper {\n  border-radius: 16px;\n  margin: 1rem auto;\n}\n\n.datamastery-info,\n.data-firsttext,\n.datamastery-info h2,\n.datamastery-info p,\n.datamastery-info .orange {\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n}\n\n.datamastery-wrapper {\n  background-color: rgba(28, 27, 38, 1);\n  border-radius: 16px;\n}\n\n.datamastery-info h2 {\n  color: #f4f4f4;\n  font-family: Eczar;\n  font-size: 3rem;\n  font-weight: 700;\n  line-height: 5rem;\n  height: 170px;\n  padding-top: 1rem;\n}\n\n.datamastery-info h2,\n.datamastery-info p {\n  text-align: center;\n  justify-content: center;\n  width: 80%;\n  margin: auto;\n  align-items: center;\n}\n\n.datamastery-info p {\n  color: rgba(179, 179, 179, 1);\n  font-weight: 400;\n  letter-spacing: 0em;\n  margin: 1rem auto;\n  font-family: Inter;\n  font-size: 1rem;\n}\n\n.track-type {\n  border-radius: 16px;\n  color: #f4f4f4;\n  background: linear-gradient(0deg, #1c1b26, #1c1b26),\n    linear-gradient(\n      180deg,\n      rgba(255, 255, 255, 0.5) 0%,\n      rgba(255, 255, 255, 0) 100%\n    );\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.track {\n  justify-content: center;\n  align-items: center;\n  padding: 2px 12px;\n  min-width: 350px;\n  border: 12px solid rgba(75, 75, 75, 0.25);\n  border-radius: 16px;\n}\n\n.track_info {\n  border-radius: 10px;\n}\n\n.wrapper {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  max-width: 1400px;\n  width: 100%;\n}\n\n.beginner-type,\n.intermediate-type {\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  margin: 1rem auto;\n  display: flex;\n  background-image: url(\"../images/Group\\ 873.png\"),\n    url(\"../images/Group\\ 874.png\");\n  background-position: center;\n  border-radius: 1rem;\n  background-size: contain;\n}\n\n.beginner-type h2,\n.intermediate-type h2 {\n  font-family: Eczar;\n  margin: auto;\n  justify-content: center;\n  align-items: center;\n  height: 7rem;\n  width: 100%;\n  border-radius: 1rem;\n  display: flex;\n  font-size: 1.6rem;\n  font-weight: 800;\n  line-height: 2.4rem;\n  text-align: center;\n  padding: 1%;\n}\n\n.beginner-type h2 {\n  background-color: rgba(207, 112, 3, 0.904);\n}\n\n.intermediate-type h2 {\n  background-color: rgba(9, 202, 250, 0.911);\n}\n\n.notes {\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  padding: 1rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 30%;\n  /* min-width: 250px; */\n  max-width: 400px;\n  text-align: center;\n}\n\n.notes h4 {\n  width: 300px;\n  font-size: 16px;\n  font-weight: 600;\n  font-family: Eczar;\n  line-height: 32px;\n  margin: auto;\n  display: flex;\n  text-align: left;\n  margin-top: 8px;\n}\n\n.notes p {\n  font-family: Inter;\n  font-size: 14px;\n  line-height: 22px;\n  text-align: left;\n  margin: 1rem auto;\n  width: 300px;\n  font-weight: 400;\n}\n\n.track_btn {\n  width: 100%;\n  gap: 0;\n}\n\n.track_btn .track_modules {\n  width: 100%;\n  height: 40px;\n  margin: 2rem auto;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n}\n\n.track_modules .week-button {\n  margin: 1rem auto;\n  width: 100%;\n}\n\n.track_btn button {\n  background-color: rgba(75, 75, 75, 0.5);\n  border-style: none;\n  color: #f4f4f4;\n  width: 90%;\n  height: 38px;\n  border-radius: 4px;\n}\n\n.click_button {\n  width: 100%;\n}\n\n.track_select_btn button {\n  background-color: rgba(251, 133, 0, 1);\n  /* padding: 0.5rem 0.2rem; */\n}\n\n.track_select_btn button,\n.track_select_btn2 button {\n  width: 100%;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 32px;\n}\n\n.track_select_btn2 button {\n  background: rgba(33, 158, 188, 1);\n}\n\n.orange,\n.yellow,\n.blue {\n  font-family: Eczar;\n}\n\n/* Mentor's info section */\n\n.main_wrapper .mentors {\n  color: #fff;\n  border-radius: 16px;\n  height: 70%;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  margin: 3rem auto;\n  /* background-color: green; */\n}\n\n.mentors_images_container {\n  margin: 0 auto;\n}\n\n.ment .mentors_container h3 {\n  font-size: 18px;\n  width: 100%;\n}\n\n.ment .mentors_container p {\n  font-size: 12px;\n}\n\n.mentors_container {\n  gap: 40px;\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  margin: 40px auto;\n  justify-content: space-around;\n  /* justify-content: center; */\n  align-items: center;\n  /* background-color: red; */\n}\n\n.mentor_wraps {\n  gap: 20px;\n  background-color: transparent;\n  transition: 1.5s;\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n}\n\n.mentor_image_wrap {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n}\n\n.ment .mentor_wraps .mentor_para {\n  background: rgba(21, 20, 29, 1);\n}\n\n.mentor_wraps:hover {\n  transform: scale(1.01);\n  box-shadow: 0 0 30px -10px rgba(8, 8, 6, 0.25);\n}\n\n.ment .mentor_wraps p,\n.ment .mentor_wraps h3 {\n  background: rgba(21, 20, 29, 1);\n  text-align: center;\n}\n\n.ment .mentor_wraps {\n  background: rgba(21, 20, 29, 1);\n}\n\n.mentors .ment h1 {\n  height: auto;\n}\n\n.mentors .ment h1 .oranges {\n  color: rgba(251, 133, 0, 1);\n  font-family: Eczar;\n}\n\n.new_mentor_para {\n  width: 50vw;\n  text-align: justify;\n  margin: 0 auto;\n}\n\n.mentor_para {\n  color: #fff;\n  display: block;\n  text-align: center;\n  border: none;\n  text-align: left;\n  margin: 0.4rem;\n  /* background-color: rgba(28, 27, 38, 1); */\n}\n\n.mentors .mentors_text p {\n  width: 60%;\n  color: #b3b3b3;\n}\n\n.mentor_image {\n  width: 250px;\n  height: 250px;\n  border-radius: 50%;\n  object-fit: cover;\n  overflow: hidden;\n  display: block;\n  margin: 0 auto;\n}\n\n.ment .mentors_text {\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  margin: 72px auto 0;\n}\n\n.ment .mentors_text {\n  margin-bottom: 18px;\n}\n\n.mentors_text h1 {\n  font-family: Eczar;\n  color: #fff;\n  font-size: 48px;\n  width: 469px;\n  height: 85px;\n}\n\n.mentors_text .oranges {\n  font-size: 48px;\n  line-height: 70px;\n  color: rgba(251, 133, 0, 1);\n  font-family: Eczar;\n}\n\n.dataepic_mentors_text .oranges {\n  font-size: 48px;\n  line-height: 70px;\n  color: rgba(251, 133, 0, 1);\n  font-family: Eczar;\n}\n\n.dataepic_mentors_text p {\n  font-family: Inter;\n  line-height: 32px;\n  font-weight: 400;\n  text-align: center;\n  font-size: 16px;\n  margin-bottom: 40px;\n  width: 60%;\n}\n\n/* dataepic */\n\n.main_wrapper .data_new {\n  width: 100%;\n}\n\n.main_wrapper .data_epic {\n  border-radius: 16px;\n  height: 70%;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  margin: 0 auto 0;\n  /* background-color: yellow; */\n}\n\n.dataepic_container {\n  width: 100%;\n  gap: 20px;\n  margin: auto;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.dataepic_mentors_text {\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  height: 190px;\n  margin-bottom: 30px;\n  margin-top: 72px;\n}\n\n.data_new {\n  border-radius: 16px;\n}\n\n.dataepic_wrap {\n  box-sizing: border-box;\n  flex-wrap: wrap;\n  transition: 0.8s;\n  border: 3px solid rgba(245, 238, 238, 0.035);\n  border-radius: 16px;\n  color: #fff;\n  width: 80%;\n  /* min-width: 18.75rem; */\n  margin-bottom: 20px;\n  justify-content: space-between;\n  align-content: space-between;\n  text-align: center;\n  text-align: left;\n  background-color: rgba(28, 27, 38, 1);\n  flex: 1 1 calc(33.33% - 16px);\n}\n\n.data_epic .dataepic_para {\n  background-color: rgba(28, 27, 38, 1);\n}\n\n.dataepic_wrap:hover {\n  transform: scale(1.03);\n  box-shadow: rgba(34, 1, 1, 0.25);\n}\n\n.dataepic_images {\n  height: 85px;\n  border-radius: 16px;\n  padding: 0px 16px 18px 16px;\n  background-color: rgba(28, 27, 38, 1);\n}\n\n.dataepic_para {\n  border-radius: 12px;\n  word-wrap: break-word;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  margin-left: 0.5rem;\n}\n\n.dataepic_para h3 {\n  justify-content: center;\n  text-align: left;\n  align-items: center;\n  padding: 2px 16px 18px 16px;\n  font-family: Eczar;\n  font-size: 22px;\n  font-weight: 600;\n  background-color: rgba(28, 27, 38, 1);\n}\n\n.dataepic_para p {\n  font-size: 16px;\n  font-family: Inter;\n  padding: 0px 16px 12px 16px;\n  background-color: rgba(28, 27, 38, 1);\n  margin-bottom: 10px;\n  line-height: 30px;\n  font-weight: 400;\n  justify-content: center;\n  align-items: flex-start;\n  text-align: left;\n  color: #b3b3b3;\n}\n\n.dataepic_images img {\n  margin-top: 24px;\n  height: 50px;\n  width: 50px;\n  justify-items: center;\n  background-color: rgba(28, 27, 38, 1);\n}\n\n/* play session */\n\n.main_wrapper .session_container {\n  width: 100%;\n  text-align: center;\n  justify-content: center;\n  display: flex;\n  margin: 72px auto 36px;\n}\n\n.session_container h1 {\n  font-family: Eczar;\n  color: #f4f4f4;\n  font-size: 48px;\n  line-height: 70px;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  width: 100%;\n  margin: 0 auto;\n  height: 170px;\n  /* background-color: red; */\n}\n\n.session_container .oranges {\n  font-size: 48px;\n  line-height: 70px;\n  color: rgba(251, 133, 0, 1);\n  font-family: Eczar;\n}\n\n.play_session {\n  color: #f4f4f4;\n  align-items: center;\n  justify-content: center;\n  margin: auto;\n}\n\n.playback_sessions {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: auto;\n  border-radius: 15px;\n  border: 3px solid rgba(245, 238, 238, 0.159);\n  gap: 1rem;\n  /* margin-bottom: 72px; */\n}\n\n.playback {\n  /* height: 370px; */\n  justify-content: center;\n  align-items: center;\n  margin: 2% auto;\n  /* width: fit-content; */\n  /* min-width: 20rem; */\n}\n\n/* .playback .entry {\n  height: 20px;\n  width: 33%;\n  margin: 0 auto;\n} */\n\n.playback .entry {\n  max-width: fit-content;\n  margin: 0 auto;\n}\n\n.entry_level {\n  margin: 0 auto;\n  display: flex;\n}\n\n.main_faqwrapper .mentors_textt {\n  justify-content: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  margin: 48px auto;\n  /* height: 180px; */\n}\n\n.mentors_textt h1 {\n  font-family: Eczar;\n  color: #f4f4f4;\n  font-size: 48px;\n  width: 100%;\n  height: auto;\n  /* background-color: purple; */\n}\n\n.mentors_textt .oranges {\n  font-size: 48px;\n  line-height: 70px;\n  color: rgba(251, 133, 0, 1);\n  font-family: Eczar;\n}\n\n.accordion_one {\n  display: flex;\n  height: 100%;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  margin: 50px auto 0;\n}\n\n.accordion_two {\n  width: 100%;\n  color: #b3b3b3;\n}\n\n.accordion_three {\n  display: flex;\n  background-color: rgba(28, 27, 38, 1);\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  padding-bottom: 8px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.item {\n  cursor: pointer;\n  margin-bottom: 5px;\n  /* padding: 30px 40px; */\n}\n\n.accordion_three h2 {\n  background-color: rgba(28, 27, 38, 1);\n  font-family: Eczar;\n  font-size: 24px;\n  font-weight: 400;\n}\n\n.accordion_four {\n  background-color: rgba(28, 27, 38, 1);\n  height: auto;\n  max-height: 9999px;\n  transition: all 1.2s cubic-bezier(1, 1, 0, 0);\n}\n\n.accordion_four:hover {\n  background-color: rgba(28, 27, 38, 1);\n  transform: scale(0.8);\n}\n\n.accordion_four p {\n  background-color: rgba(28, 27, 38, 1);\n  text-align: left;\n}\n\n.accordion_three h2:hover {\n  background-color: rgba(28, 27, 38, 1);\n  transform: scale(1);\n  box-shadow: 0 0 40px -10px rgba(8, 8, 6, 0.25);\n  transition: (1.5s);\n}\n\n.accordion_five {\n  background-color: rgba(28, 27, 38, 1);\n  max-height: 0;\n  overflow: hidden;\n  transition: all 1.5s cubic-bezier(1, 1, 1, 1);\n}\n\n.accordion_five p {\n  background-color: rgba(28, 27, 38, 1);\n  text-align: left;\n}\n\n.sign {\n  background-color: rgba(28, 27, 38, 1);\n  padding-right: 12px;\n}\n\n@media (min-width: 1200px) {\n  .about_scroll,\n  .datamastery-container {\n    padding: 0;\n  }\n\n  .about_scroll h1 {\n    width: 100%;\n  }\n\n  .main_wrapper .datamastery-container {\n    height: 110vh;\n    padding: 10px;\n    width: 96%;\n  }\n\n  .datamastery-info p {\n    padding: 1%;\n  }\n\n  #track,\n  #track_second,\n  #last_track {\n    height: auto;\n  }\n\n  .dataepic_container,\n  .play_session {\n    width: 90%;\n  }\n\n  .main_faqwrapper {\n    width: 90%;\n    margin: 0 auto;\n  }\n\n  .notes,\n  .notes p {\n    padding: 0;\n    margin-bottom: 0;\n  }\n}\n\n@media (min-width: 992px) and (max-width: 1199.98px) {\n  .hero-content p {\n    margin-top: 10%;\n  }\n\n  .main_wrapper .datamastery-container {\n    width: 90%;\n    height: 130vh;\n  }\n\n  .main_wrapper .datamastery-wrapper {\n    height: 100%;\n    padding: 0;\n    margin: 0;\n  }\n\n  .datamastery-info,\n  .hero-content p {\n    background: transparent;\n  }\n\n  .track-type .track {\n    width: 31%;\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  }\n\n  #track,\n  #track_second,\n  #last_track {\n    height: auto;\n  }\n\n  .notes {\n    width: 100%;\n    padding: 0;\n    /* height: 200px; */\n    /* max-height: 300px; */\n    margin: 0 auto;\n  }\n\n  .notes h4 {\n    margin: 0 auto;\n    width: 100%;\n    height: 100%;\n  }\n\n  .notes p {\n    max-width: 100%;\n    width: 100%;\n    padding: 0;\n  }\n\n  .track_btn {\n    width: 100%;\n  }\n\n  .track_btn .track_modules {\n    margin: 0 auto;\n    margin-bottom: 1rem;\n  }\n\n  .track_modules .week-button {\n    width: 80%;\n  }\n\n  .track_select_btn button,\n  .track_select_btn2 button {\n    width: 100%;\n    padding-left: 1px;\n    padding-right: 1px;\n  }\n\n  .beginner-type h2,\n  .intermediate-type h2 {\n    font-size: 1.6rem;\n  }\n\n  .new_mentor_para p {\n    padding: 20px;\n    width: 80%;\n    margin: 0 auto;\n  }\n\n  .mentors_container {\n    width: 90%;\n  }\n\n  .mentor_wraps {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  }\n\n  .dataepic_mentors_text,\n  .main_faqwrapper {\n    width: 90%;\n    margin: 0 auto;\n  }\n\n  .hero-content,\n  .about_scroll,\n  .about_scroll,\n  .session_container h1,\n  .new_mentor_para {\n    width: 90%;\n  }\n\n  .dataepic_mentors_text p {\n    width: 80%;\n  }\n\n  .dataepic_container {\n    width: 90%;\n    gap: 20px;\n  }\n\n  .dataepic_images {\n    padding: 0.5rem;\n  }\n\n  .dataepic_para h3,\n  .dataepic_para p {\n    padding: 0;\n  }\n\n  .dataepic_para {\n    width: 100%;\n    margin: 0 auto;\n    padding: 0.5rem;\n  }\n  .play_session {\n    width: 96%;\n  }\n  .playback {\n    background-color: transparent;\n    display: flex;\n  }\n  .playback_sessions img {\n    width: 90%;\n    margin: auto 10px;\n    padding: 2%;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 991.98px) {\n  .container {\n    width: 90%;\n  }\n\n  .about_scroll {\n    width: 80%;\n  }\n\n  .main_wrapper .datamastery-container {\n    height: 190vh;\n  }\n\n  .datamastery-info h2 {\n    font-size: 2.5rem;\n    line-height: 4rem;\n  }\n\n  .datamastery-info p {\n    padding: 0;\n    padding-bottom: 2%;\n  }\n\n  #track,\n  #track_second,\n  #last_track {\n    height: auto;\n  }\n\n  .track_btn .track_modules {\n    margin: 0 auto;\n    margin-bottom: 1rem;\n  }\n\n  .new_mentor_para {\n    width: 80%;\n  }\n\n  .mentors_container {\n    display: grid;\n  }\n\n  .mentor_wraps {\n    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  }\n\n  .dataepic_para {\n    height: auto;\n    padding: 0;\n    margin: 0;\n  }\n\n  .dataepic_mentors_text p {\n    width: 80%;\n  }\n\n  .dataepic_images {\n    padding: 0.5rem;\n  }\n\n  .dataepic_para h3 {\n    height: 80px;\n    margin: 0;\n    padding: 8px 10px 0 10px;\n  }\n\n  .dataepic_para p {\n    padding: 0 10px 0 10px;\n  }\n  .playback_sessions {\n    width: 100%;\n  }\n  .playback_sessions img {\n    width: 200px;\n  }\n\n  .playback {\n    width: 100%;\n  }\n\n  .play_session {\n    width: 96%;\n  }\n  .playback {\n    background-color: transparent;\n    display: flex;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 830px) {\n  .main_wrapper .datamastery-container {\n    height: 220vh;\n  }\n\n  .about_scroll,\n  .track-type {\n    width: 100%;\n  }\n\n  .wrapper {\n    width: 100%;\n  }\n\n  .beginner-type,\n  .intermediate-type {\n    width: 90%;\n  }\n\n  .beginner-type h2,\n  .intermediate-type h2 {\n    height: 6rem;\n    font-size: 2rem;\n  }\n\n  .track-type,\n  .wrapper,\n  #track,\n  #track_second,\n  #last_track {\n    width: 90%;\n    margin: 0 auto;\n  }\n\n  .notes {\n    width: 100%;\n    max-width: 90%;\n    margin: 0 auto;\n    padding: 0;\n  }\n\n  .notes h4,\n  .notes p {\n    width: 100%;\n    padding: 0;\n    text-align: left;\n    justify-content: left;\n  }\n\n  .track_btn {\n    width: 90%;\n    margin: 0 auto;\n  }\n\n  .track_btn .track_modules {\n    width: 100%;\n    gap: 20px;\n  }\n\n  .track_btn button {\n    width: 100%;\n    gap: 10px;\n  }\n\n  .track_select_btn button,\n  .track_select_btn2 button {\n    width: 90%;\n    margin: 0 auto;\n  }\n\n  /* .dataepic_wrap {\n    margin: 0 auto;\n    height: 100%;\n    background-color: orange;\n  } */\n\n  .dataepic_para h3 {\n    margin: 0;\n    height: 10%;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .container {\n    width: 90%;\n  }\n\n  .dataepic_wrap {\n    flex: 1 1 100%;\n  }\n\n  .about_scroll {\n    width: 100%;\n  }\n\n  .mentors_textt h1,\n  .session_container h1,\n  .dataepic_mentors_text h1,\n  .datamastery-info h2 {\n    font-size: 2rem;\n    line-height: 60px;\n  }\n\n  .maintext_para p {\n    font-size: 1rem;\n    width: 96%;\n    height: auto;\n  }\n\n  .about_scroll,\n  .track-type {\n    width: 100%;\n  }\n\n  .about_scroll h1 {\n    font-size: 1.6rem;\n    line-height: 1.7;\n  }\n\n  .about_scroll .mini-text p {\n    font-size: 1rem;\n    width: 96%;\n    margin: 2rem auto;\n  }\n\n  .red {\n    padding: 0;\n    margin: 0;\n  }\n\n  .datamastery-info h2 {\n    line-height: 1.5;\n    font-size: 40px;\n    width: 90%;\n    margin-top: 0.6rem;\n    margin-bottom: 1rem;\n  }\n\n  .datamastery-info p {\n    margin: 0 auto;\n    padding: 0;\n    width: 90%;\n    font-size: 16px;\n    font-family: \"Inter\", sans-serif;\n    line-height: 1.5;\n    font-weight: 400;\n  }\n\n  .wrapper {\n    width: 100%;\n  }\n\n  #track,\n  #track_second,\n  #last_track {\n    width: 100%;\n    height: auto;\n  }\n\n  .beginner-type,\n  .intermediate-type {\n    width: 98%;\n  }\n\n  .beginner-type h2,\n  .intermediate-type h2,\n  .new_mentor_para h1 {\n    font-size: 36px;\n    padding: 0.2rem;\n    line-height: 1.1;\n  }\n\n  .track-type,\n  .wrapper {\n    width: 98%;\n    margin: 1rem auto;\n    height: auto;\n  }\n\n  .notes {\n    width: 100%;\n    max-width: 96%;\n    margin: 0 auto;\n    padding: 0;\n  }\n\n  .notes h4,\n  .notes p {\n    width: 100%;\n    padding: 0;\n    text-align: left;\n    justify-content: left;\n  }\n\n  .notes h4 {\n    font-size: 20px;\n  }\n\n  .note p {\n    font-size: 16px;\n  }\n\n  .track_btn {\n    width: 100%;\n    margin: 0 auto;\n  }\n\n  .track_btn button {\n    width: 96%;\n    line-height: 1.2;\n    height: 45px;\n  }\n\n  .click_button {\n    width: 100%;\n  }\n\n  .new_mentor_para h1 {\n    margin: 1rem auto;\n  }\n\n  .new_mentor_para h1,\n  .new_mentor_para .oranges {\n    font-size: 48px;\n    background-color: transparent;\n  }\n\n  .new_mentor_para p {\n    font-size: 16px;\n  }\n\n  .new_mentor_para,\n  .new_mentor_para p {\n    width: 100%;\n  }\n\n  .mentors_container {\n    width: 100%;\n    display: grid;\n    padding: 0;\n  }\n\n  .mentor_wraps {\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  }\n\n  .mentor_para {\n    margin: 0;\n  }\n\n  .mentor_para p,\n  .mentor_para h3 {\n    line-height: 1.2;\n  }\n\n  .dataepic_mentors_text {\n    margin: 4rem auto;\n    width: 100%;\n    padding: 0;\n  }\n\n  .dataepic_mentors_text h1,\n  .dataepic_mentors_text h1 .oranges {\n    font-size: 48px;\n  }\n  .dataepic_mentors_text p {\n    width: 100%;\n    margin: 0;\n  }\n\n  .dataepic_container {\n    width: 100%;\n    flex-direction: column;\n  }\n\n  .dataepic_wrap {\n    margin: 0 auto;\n    width: 100%;\n  }\n\n  .dataepic_para h3 {\n    margin: 0;\n  }\n\n  .session_container {\n    margin: 0;\n    padding: 0;\n  }\n\n  .session_container h1,\n  .session_container .oranges {\n    line-height: 1.5;\n    font-size: 48px;\n    height: auto;\n    margin: 2rem auto;\n  }\n\n  .playback_sessions {\n    display: grid;\n    width: 100%;\n    gap: 1rem;\n  }\n\n  .playback {\n    display: flex;\n  }\n\n  .playback img {\n    width: 100%;\n    margin: 0;\n  }\n\n  .mentors_textt .oranges,\n  .mentors_textt h1 {\n    font-size: 48px;\n    line-height: 1.5;\n  }\n}\n\n/* Extra small devices (phones) */\n@media screen and (max-width: 576px) {\n  .datamastery-container h2,\n  .dataepic_mentors_text h1,\n  .dataepic_mentors_text h1 .oranges,\n  .new_mentor_para h1,\n  .new_mentor_para h1 .oranges,\n  .session_container h1,\n  .session_container h1 .oranges,\n  .mentors_textt h1,\n  .mentors_textt h1 .oranges {\n    font-size: 30px;\n    width: 96%;\n  }\n\n  .session_container h1,\n  .session_container h1 .oranges{\n    margin: 0;\n    padding: 0;\n    background-color: transparent;\n    line-height: 1.2;\n    margin-bottom: 24px;\n  }\n  .beginner-type,\n  .beginner-type h2,\n  .intermediate-type h2 {\n    width: 100%;\n    font-size: 1.3em;\n  }\n  .dataepic_wrap{\n    margin-top: 24px;\n  }\n   .dataepic_para h3,\n  .dataepic_para p {\n      padding: 0px 2px 2px 2px;\n\n  }\n.faq-wrappers{\n  margin: 0;\n}\n  .accordion_three h2{\n    font-size: 18px;\n  }\n\n  .accordion_four p{\n    font-size: 16px;\n    line-height: 1.5;\n  }\n}\n\n/* Small devices (tablets) */\n@media screen and (max-width: 768px) {\n  .hero-container {\n    min-height: auto;\n  }\n\n  .track {\n    min-width: unset;\n  }\n\n  .mentors_text h1 {\n    width: unset;\n  }\n\n  .mentors_text p {\n    width: unset !important;\n    padding-inline: clamp(1rem, 5%, 2rem);\n  }\n\n  .web_container {\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n  }\n\n  .web_container::-webkit-scrollbar,\n  .hero-container::-webkit-scrollbar,\n  .trackmain_container::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n/* Medium devices (laptops) */\n@media screen and (max-width: 992px) {\n}\n\n/* Large devices (desktops) */\n@media screen and (max-width: 1200px) {\n}\n\n/* Extra large devices */\n@media screen and (max-width: 1400px) {\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
